import React from 'react';
import Layout from '@common/layout';
import Header from '@common/header';
import Content from '@common/content';
import Footer from '@common/footer';
import Terms from '@components/terms';
import { useTerms } from '@repository/terms/useTerms';
import { useUserInfo } from '@repository/auth/useUserInfo';
import { TERMS } from '@domain/constant/termsType';

const TermsNHISPage = () => {
  const { data: userData } = useUserInfo();
  const { data: termsData } = useTerms({
    termType: TERMS.NHIS_PRIVACY_PROVISION,
    termRequired: true,
    options: { enabled: !!userData },
  });
  const title = termsData?.[0]?.title ?? '';

  if (!termsData) return null;

  return (
    <Layout>
      <Header />
      <Content>
        <Terms title={title} termsList={termsData} />
      </Content>
      <Footer />
    </Layout>
  );
};

export default TermsNHISPage;
